let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aLMAy")).then(() => parcelRequire('glx9n'));